module.exports = __webpack_public_path__ + "static/media/cat10.01f5e6b8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat10.jpeg
// module id = 42
// module chunks = 0